export const validationRules = {
  appleStoreUrlOrExternal: {
    base: {
      max: 1024,
    },
  },
  googlePlayUrlOrExternal: {
    base: {
      max: 1024,
    },
  },
};

export const splitIgdbIds = (igdbIds = ''): string[] => {
  return igdbIds.split(/[\s,]+/).filter(Boolean);
};

export const getIgdbIdsRequestValue = (igdbIds?: string[]): number[] | undefined => {
  if (igdbIds === undefined) return undefined;

  return igdbIds
    .map(Number)
    .filter((igdbId, index, ids) => ids.indexOf(igdbId) === index);
};

export const formatIgdbIds = (igdbIds?: number[]): string[] | undefined => {
  return igdbIds?.map(String);
};
